import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setMaintenanceError as setMaintenanceErrorReducer } from 'core/store/layout';
import { layoutSelector } from 'core/store/layout/selectors';
import { useAppDispatch, useAppSelector } from 'core/store/store.utils';
import {
  getMaintenanceErrorHandler,
  getNavigate,
  setMaintenanceError,
  setMaintenanceErrorHandler,
  setNavigate,
} from 'shared/utils/maintenance.utils';

export const MaintenanceContainer = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const layout = useAppSelector(layoutSelector);
  const { maintenanceError } = layout;

  useEffect(() => {
    if (!getNavigate()) setNavigate(navigate);
    if (!getMaintenanceErrorHandler())
      setMaintenanceErrorHandler(payload => dispatch(setMaintenanceErrorReducer(payload)));
    setMaintenanceError(maintenanceError);
  }, [maintenanceError]);

  return children;
};
